export default {
  mounted() {
    this.replaceArrows();
  },

  methods: {
    replaceArrows() {
      const icons = [...document.querySelectorAll('.js-replace-arrows .v-input__append-inner .mdi-menu-down, .js-replace-arrows .v-input__append-inner .dropdown-arrow')];

      for (let icon of icons) {
        const img = document.createElement('img');
        img.className = `v-icon icon-dropdown-arrow`;
        img.src = `/img/icons/dropdown-arrow.svg`;
        icon.parentNode.replaceChild(img, icon);
      }
    }
  },
}
